import { createAction } from 'utils/redux'

export const receiveMarkedTime = (name: string, time: number) => createAction({
  type: 'RECEIVE_MARKED_TIME',
  payload: { name, time }
})

export const setHasSentImpression = () => createAction({
  type: 'SET_HAS_SENT_IMPRESSION'
})

export const receiveInitTimestamp = (payload: number) => createAction({
  type: 'RECEIVE_INIT_TIMESTAMP',
  payload
})

export const receiveServerResponseSize = payload => createAction({
  type: 'RECEIVE_SERVER_RESPONSE_SIZE',
  payload
})
